import { conf } from 'config';
import { Observable } from 'rxjs';
import { Auth0Service } from 'services/Auth0Service';
import { HttpError, HttpUtils } from 'services/HttpService';
import { HTTP_ERROR_CODE } from 'store/types/HttpTypes';
import { Auth0User } from 'store/types/Profile';

export function httpRequestWrapper<T>({
  requestFactory,
  requireAuth = false,
}: {
  requestFactory: (headers?: Record<string, string>) => Observable<T>;
  requireAuth?: boolean;
}): Promise<T> {
  if (!requireAuth) {
    return requestFactory()
      .toPromise()
      .catch((error: HttpError) => {
        return Promise.reject(HttpUtils.getErrorMessage(error));
      });
  }

  return Auth0Service.getUser()
    .then((auth0User: Auth0User) => {
      if (
        !auth0User?.idToken ||
        !auth0User.idTokenPayload ||
        !auth0User.idTokenPayload['https://semi.org/ams_id'] ||
        !auth0User.idTokenPayload[conf.netSuite.semiEmailKey]
      ) {
        return Promise.reject(new HttpError(HTTP_ERROR_CODE.BAD_REQUEST, 'Missing user credentials.'));
      }

      const headers = {
        Authorization: `Bearer ${auth0User.idToken}`,
      };

      return requestFactory(headers).toPromise();
    })
    .catch((error: HttpError) => {
      return Promise.reject(HttpUtils.getErrorMessage(error));
    });
}
